export const data = {
    places: [
        {
            id: 0,
            title: 'Istanbul, Turkey',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 3.webp'
        },
        {
            id: 1,
            title: 'Sydney, Australia',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 3 (1).webp'
        },
        {
            id: 2,
            title: 'Baku, Azerbaijan',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 4.webp'
        },
        {
            id: 3,
            title: 'Malé, Maldives',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 4 (1).webp'
        },
        {
            id: 4,
            title: 'Paris, France',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 3 (2).webp'
        },
        {
            id: 5,
            title: 'New York, US',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 4 (2).webp'
        },
        {
            id: 6,
            title: 'London, UK',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 3 (3).webp'
        },
        {
            id: 7,
            title: 'Tokyo, Japan',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 3 (4).webp'
        },
        {
            id: 8,
            title: 'Dubai, UAE',
            entertainment: 'Flights • Hotels • Resorts',
            img: './assets/img/Rectangle 4 (3).webp'
        },
    ],
    slider: [
        {
            id: 0,
            img: './assets/img/SliderIMG1.webp',
            srcset: './assets/img/SliderIMG1Small.webp 450w, ./assets/img/SliderIMG1.webp 1440w',
            alt: 'SlideIMG1',
        },
        {
            id: 1,
            img: './assets/img/SliderIMG2.webp',
            srcset: './assets/img/SliderIMG2Small.webp 450w, ./assets/img/SliderIMG2.webp 1440w',
            alt: 'SlideIMG2',
        },
        {
            id: 2,
            img: './assets/img/SliderIMG3.webp',
            srcset: './assets/img/SliderIMG3Small.webp 450w, ./assets/img/SliderIMG3.webp 1440w',
            alt: 'SlideIMG3',
        },
        {
            id: 3,
            img: './assets/img/SliderIMG1.webp',
            srcset: './assets/img/SliderIMG1Small.webp 450w, ./assets/img/SliderIMG1.webp 1440w',
            alt: 'SlideIMG4',
        },
        {
            id: 4,
            img: './assets/img/SliderIMG2.webp',
            srcset: './assets/img/SliderIMG2Small.webp 450w, ./assets/img/SliderIMG2.webp 1440w',
            alt: 'SlideIMG5',
        },
        {
            id: 5,
            img: './assets/img/SliderIMG3.webp',
            srcset: './assets/img/SliderIMG3Small.webp 450w, ./assets/img/SliderIMG3.webp 1440w',
            alt: 'SlideIMG6',
        },
        {
            id: 6,
            img: './assets/img/SliderIMG1.webp',
            srcset: './assets/img/SliderIMG1Small.webp 450w, ./assets/img/SliderIMG1.webp 1440w',
            alt: 'SlideIMG7',
        },
        {
            id: 7,
            img: './assets/img/SliderIMG2.webp',
            srcset: './assets/img/SliderIMG2Small.webp 450w, ./assets/img/SliderIMG2.webp 1440w',
            alt: 'SlideIMG8',
        },
        {
            id: 8,
            img: './assets/img/SliderIMG3.webp',
            srcset: './assets/img/SliderIMG3Small.webp 450w, ./assets/img/SliderIMG3.webp 1440w',
            alt: 'SlideIMG9',
        }

    ],
    country: [
        {
            "name": 'United States'
        },
        {
            "name": 'Canada'
        },
        {
            "name": 'United Kingdom'
        },
        {
            "name": 'Germany'
        },
        {
            "name": 'France'
        },
        {
            "name": 'Australia'
        },
        {
            "name": 'Spain'
        },
        {
            "name": 'Italy'
        },
        {
            "name": 'Japan'
        },
        {
            "name": 'China'
        },
        {
            "name": 'India'
        },
        {
            "name": 'Brazil'
        },
        {
            "name": 'South Africa'
        },
        {
            "name": 'Mexico'
        },
        {
            "name": 'Argentina'
        },
        {
            "name": 'South Korea'
        },
        {
            "name": 'Netherlands'
        },
        {
            "name": 'Sweden'
        },
        {
            "name": 'Norway'
        }
    ]
}